/*@ngInject*/
const RuleConditionController = function ($rootScope, $stateParams, $element, localization, ruleMediator, ruleUtil, umStudioConstant, ruleModel) {
    $element.addClass('ruleCondition');

    localization.getTranslations().then(function (translations) {
        this.getConditionType = function () {
            return ruleUtil.getConditionType(this.ruleCondition.objectUri);
        };

        this.doDeleteGroup = function (ruleConditionGroup) {
            this.onDeleteSubcondition({subcondition: ruleConditionGroup});
            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.deleteCondition = function () {
            this.onDeleteSubcondition({subcondition: this.ruleCondition});
            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.onRawConditionChange = function () {
            $rootScope.$broadcast(umStudioConstant.event.RULE_UPDATED);
        };

        this.getConditionString = function () {
            var conditionString = '';

            if (this.ruleCondition.lhs.objectUri.indexOf('FieldValue') !== -1) {
                conditionString += this.ruleCondition.lhs.formTemplateUniqueName + ':' + this.ruleCondition.lhs.fieldName;
            } else if (this.ruleCondition.lhs.objectUri.indexOf('PropertyValue') !== -1) {
                conditionString += this.ruleCondition.lhs.objectName + ':' + this.ruleCondition.lhs.propertyName;
            }

            conditionString += ' ' + this.ruleCondition.operatorName;

            conditionString += ' ' + this.ruleCondition.rhs.valueString;

            return conditionString;
        };

        this.getNegationTooltip = function () {
            if (this.isUnaryCondition) {
                return _.get(translations, 'ruleCondition.removeNegation');
            }

            return _.get(translations, 'ruleCondition.negateCondition');
        };

        this.toggleNegation = function () {
            this.onToggleNegation({ruleCondition: this.ruleCondition, isUnaryCondition: this.isUnaryCondition});
        };

    }.bind(this));
};

angular.module('umCore')
    .controller('ruleConditionController', RuleConditionController);
